import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';

export class AttachmentsVO {
  id: number;
  attachmentName: string;
  fileDescription: string;
  personId: number;
  filesToUpload: Array<File>;
  attachment: string;
  originalFileName: string;
  uploadDate: string;
  isActive: string;
  createdBy: string;
  createdTime: Date;
  lastUpdatedBy: string;
  lastUpdatedTime: Date;
  attachmentsNotesList: [];
  category: string;
  isPublic: string;
}
export class AttachmentsSearchVO {
  personId: number;
  fileName: string;
  fileDescription: string;
  status: string;
  category: string;
  isPublic: string;
  userName: string;
  pageNo: number;
  pageSize: number;

}
export class AttachmentsUpdateVO { 
  id: number;
  fileDescription: string;
  category: string;
  isPublic: string;
  userName: string;

}
export class AttachmentsRes {
  apiResponseVO: ApiResponse;
  attachmentsVOList: AttachmentsVO[];
}

export class DownloadFileVO {
  message: string;
  response: string;
  fileContent: string[];
  fileName: string;
}
export class AttachmentRequest {
  personId: number;
  fileDescription: string;
  userName: string;
  isPublic: string;
  category: string;
}